/**
 * Format an activity price for display.
 *
 * Verwerkt allerlei inkonsistente input van organisatoren:
 *   - null / undefined → 'Gratis'
 *   - 0 / '0' / '' → 'Gratis'
 *   - 'gratis' (case-insensitive) → 'Gratis'
 *   - '5' / '12,50' / '5.00' → '€ 5' / '€ 12,50' / '€ 5.00' (€-prefix toegevoegd)
 *   - '€5' / 'EUR 5' / '5 EUR' → behoud bestaande markering
 */
export const formatPrice = (price) => {
  if (price === null || price === undefined) return 'Gratis';
  const raw = typeof price === 'number' ? String(price) : String(price).trim();
  if (!raw) return 'Gratis';
  const lower = raw.toLowerCase();
  if (lower === 'gratis' || lower === 'free' || raw === '0' || raw === '0,-' || raw === '0,00' || raw === '0.00' || lower === '€0' || lower === '€ 0') {
    return 'Gratis';
  }
  // Reeds van valuta-markering voorzien → laat staan
  if (/[€$£]|eur|euro/i.test(raw)) {
    return raw;
  }
  // Begint met cijfer → prefix met €
  if (/^[0-9]/.test(raw)) {
    return `€ ${raw}`;
  }
  // Anders: laat de tekst staan (bv. "Op donatiebasis")
  return raw;
};
